import { render, staticRenderFns } from "./jsList.vue?vue&type=template&id=71c3a41a&scoped=true"
import script from "./jsList.vue?vue&type=script&lang=js"
export * from "./jsList.vue?vue&type=script&lang=js"
import style0 from "./jsList.vue?vue&type=style&index=0&id=71c3a41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3a41a",
  null
  
)

export default component.exports